import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Box, Breadcrumbs, IconButton, Link, Stack, Typography } from '@mui/material';

import { PaperCard } from 'components/Card';
import { IconWrapper } from 'components/Icon';

export const SetupOverlay = ({ procurementName, crumbs, isModalOpen, onClose, children }) => {
  const items = procurementName
    ? [{ label: procurementName, onClick: onClose }, ...crumbs]
    : crumbs;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && !isModalOpen) onClose();
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, onClose]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  const content = (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        bgcolor: '#fff',
        zIndex: (theme) => theme.zIndex.modal,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <PaperCard
        height={69}
        sx={{
          px: 4,
          py: 2,
          border: 0,
          borderRadius: 0,
          boxShadow: 26,
          display: 'flex',
          boxSizing: 'border-box',
          flexShrink: 0,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
          <Breadcrumbs
            separator={
              <IconWrapper
                icon="chevronRight"
                sx={{ svg: { width: 14, height: 14, color: 'grey.300', stroke: 'grey.300' } }}
              />
            }
          >
            {items.map(({ label, onClick }, index) =>
              index === items.length - 1 ? (
                <Typography key={index} fontWeight={700} color="text.primary">
                  {label}
                </Typography>
              ) : !onClick ? (
                <Typography key={index} color="text.secondary">
                  {label}
                </Typography>
              ) : (
                <Link
                  key={index}
                  component="button"
                  type="button"
                  variant="body1"
                  color="text.secondary"
                  onClick={onClick}
                >
                  {label}
                </Link>
              )
            )}
          </Breadcrumbs>
          <IconButton color="primary" aria-label="Close" onClick={onClose}>
            <IconWrapper
              icon="xMark"
              sx={{ svg: { mt: -1, color: 'text.primary', stroke: 'text.primary' } }}
            />
          </IconButton>
        </Stack>
      </PaperCard>

      <Box
        sx={{ flex: 1, overflowY: 'auto', px: 8, py: 4, display: 'flex', flexDirection: 'column' }}
      >
        {children}
      </Box>
    </Box>
  );

  return ReactDOM.createPortal(content, document.body);
};
